import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=faf1ee8a&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=faf1ee8a&prod&scoped=true&lang=scss"
import style1 from "./Header.vue?vue&type=style&index=1&id=faf1ee8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf1ee8a",
  null
  
)

export default component.exports